module.exports = __webpack_public_path__ + "img/more-work.ff5c1dca.png";